import styled, { css } from "react-emotion";

const StyledButton = styled("button")`
  background-color: #89d2d3;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 15px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
  color: white;
  outline: none;
  padding: 8px 30px;
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background: #96d2d3cc;
  }
`;

function Button({ children, disabled, ...props }) {
  return <StyledButton {...props}>{children}</StyledButton>;
}

export default Button;
